<template>
    <div class="d-flex flex-column">
        <span class="visually-hidden">{{ offerNameAccessibility }}</span>
        <ob1-boutons
            :class="additionalClasses"
            data-bs-toggle="modal"
            :data-bs-target="'#' + popinId"
            :is-primary="isPrimary"
            :is-secondary="!isPrimary"
            :is-inverse="isInverse"
            :is-wide="isWide"
            :is-button="!isLink"
            :label="label"
            aria-hidden="true"
            :data-oevent-category="trackingCategory"
            :data-oevent-action="formattedTrackingAction"
            :data-oevent-label="trackingLabel"
        />

        <div class="row">
            <with-device-popin-cds
                v-if="fromCds"
                :id="popinId"
                :with-device-section="popinCtasDto.withDeviceSection"
                :without-device-section="popinCtasDto.withoutDeviceSection"
                :title="popinCtasDto.title"
                :description="popinCtasDto.description"
                :visual="popinCtasDto.visual"
                :is-sub="isSub"
            />
            <with-device-popin
                v-else
                :id="popinId"
                :with-device-section="popinCtasDto.withDeviceSection"
                :without-device-section="popinCtasDto.withoutDeviceSection"
                :title="popinCtasDto.title"
                :description="popinCtasDto.description"
                :visual="popinCtasDto.visual"
            />
        </div>
    </div>
</template>
<script>
import WithDevicePopin from "./WithDevicePopin.vue";
import WithDevicePopinCds from "./WithDevicePopinCds.vue";

export default {
    name:"OfferCtaWithDevicePopin",
    components: {
        WithDevicePopinCds,
        WithDevicePopin
    },
    props: {
        label: {
            type: String,
            required: true
        },
        isPrimary: {
            type: Boolean,
            required: true
        },
        isInverse: {
            type: Boolean,
            required: false
        },
        isWide: {
            type: Boolean,
            required: false
        },
        isLink:{
          type: Boolean,
            required: false
        },
        popinId: {
            type: String,
            required: true
        },
        popinCtasDto: {
            type: Object,
            required: true
        },
        //Pour le choc de simplification
        fromCds: {
            type: Boolean,
            required: false,
            default: false
        },
        //Pour le choc de simplification
        isSub: {
            type: Boolean,
            required: false,
            default: false,
        },

        offerName: {
            type: String,
            required: true
        },
        trackingCategory: {
            type: String,
            required: true
        },
        trackingLabel: {
            type: String,
            required: true
        },
        trackingAction: {
            type: String,
            required: false,
            default: ""
        },
        additionalClasses: {
            type: String,
            default: ""
        }
    },
    computed: {
        offerNameAccessibility() {
            return "Ajouter le nouveau forfait " + this.offerName;
        },
        formattedTrackingAction() {
            const actionLabel = this.trackingAction ? this.trackingAction : this.label;
            return stripAccents(actionLabel).split(' ').join('_');
        }
    }
}
</script>
